import React from "react";
import { AspectRatio, Flex } from "@chakra-ui/react";
import { type Integration } from "lib/sanity";
import { SyncRow } from "./sync-row";

type Step3FigureProps = {
  source: Integration;
  destination: Integration;
};

export function Step3Figure({ source, destination }: Step3FigureProps) {
  return (
    <AspectRatio as="figure" ratio={5 / 4} bg="white" w="100%" borderRadius="4px">
      <Flex direction="column" gap={5} w="100%" h="100%" p={{ base: 7, xl: 12 }}>
        <SyncRow source={source} destination={destination} sourceText="Email" destinationText="Email" />

        <SyncRow source={source} destination={destination} sourceText="Name" destinationText="Name" />

        <SyncRow source={source} destination={destination} sourceText="Total_orders" destinationText="All_orders" />

        <SyncRow source={source} destination={destination} sourceText="Last_login" destinationText="Last_login" />
      </Flex>
    </AspectRatio>
  );
}
